import CampaignsIcon from 'Assets/Images/icons/campaigns'
import { PATHS } from 'Config/Routing/paths'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import EditIcon from '@material-ui/icons/Edit'
import { Breadcrumb } from 'react-breadcrumbs'

import { Breadcrumbs } from 'Components/Breadcrumbs'
import { CampaignPageWrapper } from 'Components/Campaigns/Page/CampaignPageWrapper/index'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { LogoRound } from 'Components/LogoRound'
import { PageTitle } from 'Components/PageTitle'

import { CampaignHeaderNav } from 'Containers/Campaigns/Page/HeaderNav'

import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { Link } from 'react-router-dom'
import StyledIconButton from '../../../Components/Form/StyledIconButton'

class CampaignPage extends Component {
  render() {
    const { campaign, campaignId, match } = this.props
    const showBonusTab = campaign.bonusLimit
    return (
      <CampaignPageWrapper>
        <LayoutDashboard className="campaign-main-info">
          <Breadcrumbs icon={<CampaignsIcon style={{ width: 16 }} />} />
          <Breadcrumb
            data={{
              title: 'Campaigns',
              pathname: `${PATHS.main.dashboard}${
                PATHS.dashboard.campaigns
              }?Status=Active`,
            }}
          />
          <Breadcrumb
            data={{
              title: campaign.name,
              pathname: `${PATHS.main.dashboard}${
                PATHS.dashboard.campaigns
              }?Status=Active${campaignId}`,
            }}
          />
          <PageTitle>
            {campaign.name}
            <Link
              style={{ float: 'right' }}
              to={`${PATHS.main.dashboard}${
                PATHS.dashboard.campaigns
              }/${campaignId}${PATHS.campaign.edit}`}
            >
              <StyledIconButton>
                <EditIcon />
              </StyledIconButton>
            </Link>
          </PageTitle>
          <LogoRound logo={campaign.client ? campaign.client.logo : ''} />
        </LayoutDashboard>
        <CampaignHeaderNav
          active={this.props.active}
          campaignId={this.props.campaignId}
          match={match}
          history={this.props.history}
          showBonusTab={showBonusTab}
        />
        <HideWhenBlocked>{this.props.children}</HideWhenBlocked>
      </CampaignPageWrapper>
    )
  }
}

CampaignPage.propTypes = {
  campaign: PropTypes.object.isRequired,
}

const mapStateToProps = (state, props) => ({
  campaign: state.campaigns.campaigns[props.campaignId],
})

export default connect(mapStateToProps)(CampaignPage)



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/index.js